<template>
    <b-form-group :label="label"
        :invalid-feedback="errorTxt"
        :state="state">
        <b-input-group :prepend="$t('network')">
            <b-form-select
                v-model="inputVal"
                :options="options"
                :state="state"
                :disabled="disabled">
            </b-form-select>
        </b-input-group>
    </b-form-group>
</template>

<script>
    export default {
        props: {
            model: Object,
            countryAttribute: String,
            label: String,
            errors: Array,
            disabled: Boolean
        },
        data() {
            return {
                inputVal: this.model['network'] ? this.model['network'] : null,
                state: null,
                errorTxt: '',
                options: [],
                country: null
            }
        },
        watch: {
            model: {
                handler(val) {
                    this.state = null;
                    this.errorTxt = '';
                    this.inputVal = val['network'];

                    if (this.countryAttribute && val[this.countryAttribute] !== this.country) {
                        this.model['network'] = null;
                        this.inputVal = null;
                        this.country = this.model[this.countryAttribute] ? this.model[this.countryAttribute] : null;
                        if (this.country != null) {
                            this.load();
                        } else {
                            this.options = [
                                {value: null, text: this.$t('select')}
                            ];
                        }
                    }
                }, deep: true
            },
            inputVal(val) {
                this.state = null;
                this.errorTxt = '';
                this.model['network'] = val;
            },
            errors(val) {
                let hasErr = false;
                if (val.length) {
                    val.forEach(v => {
                        if (v.param === 'network') {
                            this.state = false;
                            this.errorTxt = v.msg;
                            hasErr = true;
                            return;
                        }
                    });
                }
                this.state = !hasErr;
            }
        },
        methods: {
            load: function () {
                this.options = [
                    {value: null, text: this.$t('select')}
                ];
                this.$bgService.get('/phone-network', {params: {
                        page: 1,
                        pageSize: 1000,
                        status: 0,
                        country: this.country
                    }}).then(response => {
                    response.data.docs.forEach(item => {
                        this.options.push({value: item._id, text: item.name});
                    });
                });
            },
        },
        mounted() {
            if (this.countryAttribute) {
                this.country = this.model[this.countryAttribute] ? this.model[this.countryAttribute] : null;
            }
            this.load();
        },
        i18n: {
            messages: {
                en: {
                    select: 'Select network',
                },
                vi: {
                    select: 'Chọn nhà mạng',
                }
            }
        }
    }
</script>